import { takeLatest, put, call } from 'redux-saga/effects';
import { AUTH_SUBMIT_SAGA } from "../sagaTypes";
import { loaderAction, setUser } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/login`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerAuthSaga(args) {
    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('phone', args.data.phone);
        formData.append('password', args.data.password);

        const auth = yield call (request, formData);

        if (auth && auth.success) {
            // Добавляю hash в локальное хранилище
            setLocalStorage('afp_fitness', auth.user.hash).then();
            yield put(setUser(auth.user));
            growl({ type: 'success', message: auth.message });
        }
        else if (auth && auth.error) {
            growl({ type: 'error', message: auth.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherAuthSubmit() {
    yield takeLatest(AUTH_SUBMIT_SAGA, workerAuthSaga);
}